import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the formIndicator state domain
 */

const selectFormIndicatorDomain = (state) =>
  state.get("formIndicator", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingForm = () =>
  createSelector(selectFormIndicatorDomain, (state) =>
    state.get("isLoadingForm")
  )

export const makeSelectForm = () =>
  createSelector(selectFormIndicatorDomain, (state) => state.get("form"))

export const makeSelectLoadingSave = () =>
  createSelector(selectFormIndicatorDomain, (state) =>
    state.get("isLoadingSave")
  )

/**
 * Default selector used by FormIndicator
 */

const makeSelectFormIndicator = () =>
  createSelector(selectFormIndicatorDomain, (substate) => substate.toJS())

export default makeSelectFormIndicator
export { selectFormIndicatorDomain }
